import { render, staticRenderFns } from "./green-politic.vue?vue&type=template&id=1e464deb&scoped=true&"
import script from "./green-politic.vue?vue&type=script&lang=js&"
export * from "./green-politic.vue?vue&type=script&lang=js&"
import style0 from "./green-politic.vue?vue&type=style&index=0&id=1e464deb&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e464deb",
  null
  
)

export default component.exports